// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abee626f","591":"7de28a23"}[chunkId] + ".chunk.js";
};